import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import { AuthTopAppBar } from '@/features/auth/components/AuthTopAppBar'
import { AuthFooter } from '@/features/auth/components/AuthFooter'
import { LoginMarketingPanel } from '@/features/auth/components/LoginMarketingPanel'
import { LOGIN_MARKETING_PANEL_BASIS } from '@/features/auth/styles/loginLayoutConstants'
import { surfaceAuthCanvas } from '@/theme/designTokens'

/** Figma 5074-12188 — split-screen at md+; phones show the form column only. */
export function AuthSplitLayout() {
  return (
    <Box
      data-testid="auth-split-layout"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        maxHeight: '100dvh',
        overflow: 'hidden',
        bgcolor: surfaceAuthCanvas,
        backgroundColor: surfaceAuthCanvas,
      }}
    >
      <AuthTopAppBar variant="split" />
      <Box
        component="main"
        data-testid="auth-split-main"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          flex: '1 1 auto',
          minHeight: 0,
          overflowX: 'hidden',
          overflowY: { xs: 'auto', md: 'hidden' },
          WebkitOverflowScrolling: 'touch',
          width: '100%',
        }}
      >
        <LoginMarketingPanel />
        <Box
          data-testid="login-form-panel"
          sx={{
            flex: { xs: '1 1 auto', md: `0 0 ${LOGIN_MARKETING_PANEL_BASIS}` },
            width: { xs: '100%', md: LOGIN_MARKETING_PANEL_BASIS },
            maxWidth: { xs: '100%', md: LOGIN_MARKETING_PANEL_BASIS },
            minWidth: 0,
            minHeight: 0,
            height: { xs: 'auto', md: '100%' },
            alignSelf: 'stretch',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-start' },
            bgcolor: surfaceAuthCanvas,
            backgroundColor: surfaceAuthCanvas,
            px: { xs: 2.5, sm: 4 },
            py: { xs: 3, md: 2 },
            overflowX: 'hidden',
            overflowY: { xs: 'visible', md: 'auto' },
            boxSizing: 'border-box',
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <AuthFooter />
    </Box>
  )
}
